let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hvwF5")).then(() => parcelRequire('4DeQk'));